import { toast } from 'react-toastify';
import { MAIL_TEMPLATE } from '../config/apiEndPoint';
import { GET, POST, PUT } from 'config/api.config';

export const fetchMailTemplateTableAndFilterSchema = async (data = {}) => {
    try {
        const url = data?._Id
            ? `${MAIL_TEMPLATE.GET_MAIL_TEMPLATE_SCHEMA}/${data?._Id}`
            : `${MAIL_TEMPLATE.GET_MAIL_TEMPLATE_SCHEMA}`;
        const response = await GET(url, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const submitMailTemplateFilterData = async (data = {}) => {
    try {
        const response = await POST(MAIL_TEMPLATE.SUBMIT_FILTER_DATA, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getMailTemplateDefinitions = async (data = {}) => {
    try {
        const response = await GET(MAIL_TEMPLATE.GET_DEFINITIONS, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const getMailTemplateById = async (id, data = {}) => {
    try {
        const response = await GET(MAIL_TEMPLATE.GET_MAIL_TEMPLATE_BY_ID(id), data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const addMailTemplate = async (data = {}) => {
    try {
        const response = await POST(MAIL_TEMPLATE.ADD_MAIL_TEMPLATE, data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};

export const updateMailTemplate = async (id, data = {}) => {
    try {
        const response = await PUT(MAIL_TEMPLATE.UPDATE_MAIL_TEMPLATE(id), data);
        return response;
    } catch (error) {
        toast.error(error?.message);
    }
};
